// Just a page that shows a message saying the booking request was sent

// MUI IMPORTS
import { Button, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";

//THE ACTUAL PAGE
export const BookingRequestSent = () => {
  const navigate = useNavigate();

  return (
    <div className="page">
      <Typography variant="h4" gutterBottom>
        We've received your booking and we will get back to you ASAP (within 7
        days since we are currently closed and not in the office every day).
        Your card will not be charged until we review and accept your
        reservation. In the meantime, you may see a "Pending" or "Authorized"
        transaction on your card.
      </Typography>
      <Button variant="outlined" onClick={() => navigate("/")}>
        Back to home page
      </Button>
    </div>
  );
};
